//Constants
import * as ACTIONS from './actionTypes';

//Types
import { EngineDealer, CountryData, Listing, Country } from './types';
import { ActionGetEngineDealerAPISuccess, ActionGetLastSyncDateAPISuccess, ActionGetDealerCountryAPISuccess, ActionSyncEngineDealerAPISuccess, ActionGetCountryStateAPISuccess } from './actions';
import { DealerState } from 'features/Dealers/DealerSelect/state/reducer';
import LMDepartmentsReducer, { DealerDepartmentsState } from 'features/Dealers/DealerConfiguration/Departments/state/reducer';

import { ModelSyncState } from 'features/Dealers/DealerConfiguration/Modals/ModalPush/state/reducer';
import { combineReducers } from 'redux';

import dealerReducer from "features/Dealers/DealerSelect/state/reducer";

import publishReducer from "features/Dealers/DealerConfiguration/Modals/ModalPush/state/reducer";
import listingReducer, { ListingState } from 'features/Dealers/Listings/state/reducer';
import connectByLabelReducer, { ConnectByLabelState } from 'features/Dealers/ConnectByLabel/state/reducer';
import offerInsightsSagas from 'features/Dealers/Performance/state/sagas';
import { OfferInsightsState } from 'features/Dealers/Performance/state/reducer';
import offerInsightsReducer from 'features/Dealers/Performance/state/reducer';
import { PerformanceFiltersState } from 'features/Dealers/Performance/Filter/state/reducer';
import performancefiltersReducer from 'features/Dealers/Performance/Filter/state/reducer';
import { PerformanceCompletenessState }  from 'features/Dealers/Performance/Widgets/ProfileCompleteness/state/reducer';
import performancecompletenessReducer from 'features/Dealers/Performance/Widgets/ProfileCompleteness/state/reducer';
import { UrlUpgradeState }  from 'features/Home/Modals/UpsellUpgrade/state/reducer';
import urlUpgradeReducer from 'features/Home/Modals/UpsellUpgrade/state/reducer';
import { UrlSetupState }  from 'features/Home/Modals/UpsellSetup/state/reducer';
import urlSetupReducer from 'features/Home/Modals/UpsellSetup/state/reducer';

import { UrlUpgradePackageState }  from 'features/Home/Modals/UpsellUpgradePackage/state/reducer';
import urlUpgradePackageReducer from 'features/Home/Modals/UpsellUpgradePackage/state/reducer';


export interface EngineDealerState {
    enginedealer?: EngineDealer
    lastsyncdate?: Date
    countryData?: CountryData
    listingdealer?: Listing
    countries?: Country[]
}

const defaultState: EngineDealerState = {
    enginedealer: undefined,
    lastsyncdate: undefined,
    countryData: undefined,
    listingdealer: undefined,
    countries: undefined
};


type Action = ActionGetEngineDealerAPISuccess | ActionGetLastSyncDateAPISuccess | ActionGetDealerCountryAPISuccess | ActionSyncEngineDealerAPISuccess | ActionGetCountryStateAPISuccess;

function enginedealerReducer(state: EngineDealerState = defaultState, action: Action): EngineDealerState {
    switch (action.type) {
        case ACTIONS.GET_ENGINEDATA_API_SUCCESS:
            {
                const { enginedealer } = action as ActionGetEngineDealerAPISuccess;
                return {
                    ...state,
                    enginedealer: enginedealer
                }
            }
        case ACTIONS.GET_LASTSYNCDATE_API_SUCCESS:
            {
                const { lastsyncdate } = action as ActionGetLastSyncDateAPISuccess;
                return {
                    ...state,
                    lastsyncdate: lastsyncdate
                }
            }
        case ACTIONS.SYNC_DEALER_API_SUCCESS:
        case ACTIONS.UNSYNC_DEALER_API_SUCCESS:
                {
                    const { listing } = action as ActionSyncEngineDealerAPISuccess;
                    return {
                        ...state,
                        listingdealer: listing
                    }
                }
        case ACTIONS.GET_DEALERCOUNTRY_API_SUCCESS:
            {
                const{ countryData } = action as ActionGetDealerCountryAPISuccess;
                return {
                    ...state,
                    countryData: countryData
                }
            }
        case ACTIONS.GET_COUNTRYSTATE_API_SUCCESS:
            {
                const{ countries } = action as ActionGetCountryStateAPISuccess
                return {
                    ...state,
                    countries: countries
                }
            }
    }
    return {
        ...state
    }
}

export interface DealersState {
    dealer: DealerState,
    departments: DealerDepartmentsState,
    enginedealer: EngineDealerState,
    connectByLabel: ConnectByLabelState,
    modelSync: ModelSyncState
    listing: ListingState,
    offerInsights: OfferInsightsState,
    urlUpgrade: UrlUpgradeState,
    urlUpgradePackage: UrlUpgradePackageState,
    urlSetup: UrlSetupState,
    performanceFilters: PerformanceFiltersState,
    performanceCompleteness: PerformanceCompletenessState
}

const dealersReducer = combineReducers<DealersState>({
    dealer: dealerReducer,
    modelSync: publishReducer,
    departments: LMDepartmentsReducer,
    enginedealer: enginedealerReducer,
    connectByLabel: connectByLabelReducer,
    listing: listingReducer,
    offerInsights: offerInsightsReducer,
    urlUpgrade: urlUpgradeReducer,
    urlUpgradePackage: urlUpgradePackageReducer,
    urlSetup: urlSetupReducer,
    performanceFilters: performancefiltersReducer,
    performanceCompleteness: performancecompletenessReducer
})

export default dealersReducer;